import React from "react";
import { PlayIcon } from "lucide-react";

import { TestRunModalContent } from "./TestRunModalContent";

import { Variable } from "@/components/InputVariableConfigurator/types";

interface TestRunModalProps {
  workflowId: string;
  workflowName: string;
  versionNumber: string;
  workspaceId: string;
  inputVariables: Variable[];
}

// Wrapper component that provides UserChannelProvider
export const useTestRunModal = ({
  workflowId,
  workflowName,
  versionNumber,
  workspaceId,
  inputVariables,
}: TestRunModalProps) => {
  const [isOpen, setIsOpen] = React.useState(false);

  // The modal is always rendered (but hidden when closed)
  const modal = (
    <TestRunModalContent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      workflowId={workflowId}
      workflowName={workflowName}
      versionNumber={versionNumber}
      workspaceId={workspaceId}
      inputVariables={inputVariables}
    />
  );

  const buttonAction = {
    label: "Test Run",
    icon: <PlayIcon className="h-4 w-auto pr-1" aria-hidden="true" />,
    onClick: () => setIsOpen(true),
    variant: "outline" as const,
  };

  return { modal, buttonAction };
};
